





















import { Component, Prop, Vue } from "vue-property-decorator";
const sout = console.log;
@Component
export default class GradeDisplay extends Vue {
  @Prop() private gradeObject!: any;
  @Prop() private showCat!: boolean;
  @Prop() private colorScaled!: boolean;
  @Prop() private variant!: string;
  @Prop() private textVariant!: string;
  @Prop() private headerVariant!: string;
  get displayGrade(): string {
    const str = "" + this.pointsEarned;
    const b = str.length > 0;
    if (b) {
      return str;
    } else {
      return "--";
    }
  }
  get hasGrade(): boolean {
    return ("" + this.pointsEarned).length > 0;
  }
  get pointsEarned(): number {
    return this.gradeObject.grade;
  }
  get percent(): number {
    return this.pointsEarned / this.gradeObject.Points;
  }
  get colorClass(): string {
    if (!this.hasGrade) {
      return "";
    }
    if (this.percent >= 0.9) {
      return "a";
    } else if (this.percent >= 0.8) {
      return "b";
    } else if (this.percent >= 0.7) {
      return "c";
    } else if (this.percent >= 0.6) {
      return "d";
    } else {
      return "f";
    }
  }

  asPercent(num: number) {
    return "" + round(num, 2) * 100 + "%";
  }
}
function round(num: number, decimals: number) {
  const k = Math.pow(10, decimals);
  const r = Math.round(num * k);
  return r / k;
}
